import React from "react";
import PropTypes from "prop-types";
import PaginationBar from "./PaginationBar";

/**
 * Pagination for callers that know how many rows there are, and let the bar work
 * out the pages. The row count also gives them the "1–50 of 384" readout.
 */
const PaginationControls = ({
  pagination,
  onPageChange,
  onPerPageChange,
  pageSizeOptions = [50, 100, 150],
  moduleName = "Items",
}) => {
  const { currentPage = 1, total = 0, perPage = 10 } = pagination;
  const totalPages = Math.ceil(total / perPage) || 1;

  return (
    <PaginationBar
      perPageLabel={`${moduleName} per page`}
      perPage={perPage}
      perPageOptions={pageSizeOptions}
      onPerPageChange={onPerPageChange}
      currentPage={currentPage}
      totalPages={totalPages}
      totalItems={total}
      onPageChange={onPageChange}
    />
  );
};

PaginationControls.propTypes = {
  pagination: PropTypes.shape({
    currentPage: PropTypes.number,
    total: PropTypes.number,
    perPage: PropTypes.number,
  }).isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPerPageChange: PropTypes.func.isRequired,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  moduleName: PropTypes.string,
};

export default PaginationControls;
